<template>
  <validation-provider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    tag="div"
  >
    <label v-if="label" class="custom_input_label">
      {{ label }}
    </label>
    <v-autocomplete
      ref="SearchInput"
      v-bind="$attrs"
      v-on="{ ...$listeners, input: () => {} }"
      :disabled="disabled"
      :error-messages="errors[0]"
      :item-text="itemText"
      :item-value="itemValue"
      :search-input.sync="searchText"
      :value="value"
      class="search-input"
      dense
      outlined
      @input="input"
      @keyup.prevent="search"
    >
      <template v-if="customItem" #item="{ item, attrs }">
        <slot
          :attrs="attrs"
          :item="item"
          :searchText="searchText"
          name="item"
        ></slot>
      </template>
      <template
        v-if="(clearable && value) || (searchText && searchText.trim() !== '')"
        #append
      >
        <v-btn class="mt-n1" icon small @click="clear">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
      <template #prepend-inner>
        <v-progress-circular
          v-show="loading"
          color="primary"
          indeterminate
          size="18"
          width="2"
        ></v-progress-circular>
      </template>
    </v-autocomplete>
  </validation-provider>
</template>

<script>
import { debounce } from "@/utils/pureFunctions";

export default {
  name: "search-input",
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    customItem: {
      type: Boolean,
      default: false,
    },
    getWhenNoElement: {
      type: Boolean,
      default: true,
    },
    value: {},
    clearable: {
      type: Boolean,
      default: false,
    },
    label: {},
    name: {},
    rules: {},
    delay: {
      type: Number,
      default: 300,
    },
    itemText: {
      type: [String, Function],
      default: "name",
    },
    itemValue: {
      type: String,
      default: "id",
    },
    getItemPromise: {
      type: Function,
    },
    lazyLoadData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: null,
      loading: false,
      searchText: "",
    };
  },
  computed: {
    searchInput() {
      const { SearchInput } = this.$refs;
      if (SearchInput) {
        return SearchInput;
      }
      return null;
    },
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
    clear() {
      this.searchText = "";
      this.getItem("");
      this.$emit("input", null);
    },
    async getItem(value) {
      this.$emit("search", value);
      if (
        this.searchInput &&
        (!this.lazyLoadData || this.searchInput.filteredItems.length === 0) &&
        this.getItemPromise
      ) {
        this.loading = true;
        try {
          const data = await this.getItemPromise(value);
          this.$emit("founded", data);
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.loading = false;
        }
      }
    },
  },
  created() {
    this.search = debounce(function (e) {
      const isValidRegex = /[a-zA-Zа-яА-Я0-9\s]/.test(e.key);
      if ((e.key.length === 1 && isValidRegex) || e.key === "Backspace") {
        this.getItem(e.target.value);
      }
    }, this.delay);
  },
};
</script>
